import z from "zod";

export const cardActivationFormSchema = z.object({
  public_token: z
    .string()
    .min(9, { message: "Le code d'activation doit contenir 9 chiffres" })
    .max(9, { message: "Le code d'activation doit contenir 9 chiffres" }),
});

export type CardActivationFormData = z.infer<typeof cardActivationFormSchema>;
